export default "__VITE_ASSET__DxGQsCsM__"